import { template as template_466470c38bb54e40ba2c87c9d50063db } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { and, gt } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import { tracked } from '@glimmer/tracking';
import { sortBy } from '@eflexsystems/ember-composable-helpers';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import StandardModal from 'eflex/components/standard-modal';
import EmberGrid from 'eflex/components/ember-grid';
import { service } from '@ember/service';
export default class JemTaskOperationMaterials extends Component {
    @service
    store;
    @tracked
    isCollapsed = true;
    @tracked
    showMaterialsModal = false;
    @tracked
    hasWarning = false;
    toggle = ()=>{
        this.isCollapsed = !this.isCollapsed;
    };
    closeModal = ()=>{
        this.showMaterialsModal = !this.showMaterialsModal;
    };
    getMaterialWithWarnings = ()=>{
        const kineticAssemblyMaterials = this.store.peekAll('kinetic-assembly-material');
        const taskMaterials = this.args.task?.materials ?? [];
        const fieldsToCompare = [
            'partDescription',
            'relatedOperation',
            'quantityPer',
            'fixedQuantity',
            'serialTracked',
            'lotTracked'
        ];
        taskMaterials.forEach((material)=>{
            const match = kineticAssemblyMaterials.find((kineticMat)=>kineticMat.partNumber === material.partNumber && kineticMat.sequence === material.sequence);
            let hasMismatch = false;
            if (match) {
                hasMismatch = fieldsToCompare.some((field)=>material[field] !== match[field]);
            }
            if (hasMismatch) {
                this.hasWarning = true;
            }
            material.warning = hasMismatch;
            return material;
        });
        return taskMaterials;
    };
    static{
        template_466470c38bb54e40ba2c87c9d50063db(`
    {{#let (this.getMaterialWithWarnings) as |taskMaterials|}}
      {{#if (and (gt taskMaterials.length 0) @task.usesOperations)}}
        {{#if @isSingleView}}
          <button
            class="materials-button btn btn-secondary-dark"
            type="button"
            {{on "click" (fn (mut this.showMaterialsModal) true)}}
          >
            {{t "kinetic.materials"}} ({{taskMaterials.length}})
          </button>
          {{#if this.showMaterialsModal}}
            <StandardModal
              class="test-kinetic-materials-modal"
              @size="lg"
              @darkMode={{true}}
            as |modal|>
              <modal.header class="pb-2">
                <div class="d-flex align-items-center w-100 mb-3">
                  <h5 class="modal-title lh-sm">
                    {{t 'kinetic.materials'}}
                  </h5>
                  <button
                    class="btn-close d-flex align-items-center"
                    type="button"
                    {{on "click" this.closeModal}}
                  >
                    <FaIcon
                      @icon="xmark"
                      @prefix="fas"
                      @size="lg"
                      class="text-gray-100"
                    />
                  </button>
                </div>
              </modal.header>
              <modal.body class="main-overflow">
                <EmberGrid class="w-100 ember-grid-dark">
                  <thead>
                    <tr>
                      {{#if this.hasWarning}}
                        <th></th>
                      {{/if}}
                      <th>
                        {{t 'kinetic.sequence'}}
                      </th>
                      <th>
                        {{t 'kinetic.material.part'}}
                      </th>
                      <th>
                        {{t 'kinetic.material.quantityPer'}}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {{#each (sortBy "sequence" taskMaterials) as |material|}}
                      <tr class="test-material-row">
                        {{#if this.hasWarning}}
                          <td class="material-warning d-flex align-items-center flex-column">
                            {{#if material.warning}}
                              <div class="icon-message help" title={{t 'kinetic.materialMismatch'}}>
                                <FaIcon @icon="triangle-exclamation" @prefix="fas" class="fa"/>
                              </div>
                            {{/if}}
                          </td>
                        {{/if}}
                        <td class="material-sequence px-3">{{material.sequence}}</td>
                        <td class="material-part px-3">
                          {{material.partNumber}}
                          {{#if material.partDescription}} - {{material.partDescription}}{{/if}}
                        </td>
                        <td class="material-quantity-per px-3">{{material.quantityPer}}</td>
                      </tr>
                    {{/each}}
                  </tbody>
                </EmberGrid>
              </modal.body>
              <modal.footer as |footer|>
                <footer.confirm
                  @onConfirm={{this.closeModal}}
                >
                  {{t "close"}}
                </footer.confirm>
              </modal.footer>
            </StandardModal>
          {{/if}}
        {{else}}
          <div class="materials-section mx-2 my-2">
            <div
              class="materials-collapse bootstrap-table shadow-sm overflow-hidden
                d-flex align-items-center pointer bg-gray-100 w-100 p-2 {{if this.isCollapsed 'rounded' 'rounded-top'}}"
              {{on 'click' this.toggle}}
            >
              <div class="materials-button flex-fill d-flex align-items-center fw-semibold text-body me-2">
                <span class="materials">{{t "kinetic.materials"}} ({{taskMaterials.length}})</span>
              </div>
              <FaIcon @icon="caret-{{if this.isCollapsed "down" "up"}}" @prefix="fas" class="text-body"/>
            </div>
            {{#unless this.isCollapsed}}
              <div class="materials-list rounded-bottom bg-white w-100">
                <div class="row align-items-center text-gray-700 fs-4 sticky-top px-2 py-2">
                  {{#if this.hasWarning}}
                    <div class="col-1"/>
                  {{/if}}
                  <div class="col-2">{{t "kinetic.sequence"}}</div>
                  <div class="col-6">{{t "kinetic.material.part"}}</div>
                  <div class="col-3">{{t "kinetic.material.quantityPer"}}</div>
                </div>
                {{#each (sortBy "sequence" taskMaterials) as |material|}}
                  <div class="row align-items-center text-body px-2 py-2">
                    {{#if this.hasWarning}}
                      <div class="col-1 material-warning">
                        {{#if material.warning}}
                          <div class="icon-message help" title={{t 'kinetic.materialMismatch'}}>
                            <FaIcon @icon="triangle-exclamation" @prefix="fas" class="fa"/>
                          </div>
                        {{/if}}
                      </div>
                    {{/if}}
                    <div class="col-2">{{material.sequence}}</div>
                    <div class="col-6 material-part">
                      {{material.partNumber}}
                      {{#if material.partDescription}} - {{material.partDescription}}{{/if}}
                    </div>
                    <div class="col-3 material-quantity">{{material.quantityPer}}</div>
                  </div>
                {{/each}}
              </div>
            {{/unless}}
          </div>
        {{/if}}
      {{/if}}
    {{/let}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
